// extracted by mini-css-extract-plugin
export default {"schoolsTable":"DudLLOgnOznzlZm4gX1x"};